import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { all_routes } from "../../../router/all_routes";
import Cookies from "js-cookie";
import { useUserPermissions } from "../../../UserPermissionsContext";
import { Spin } from "antd";
import ImageWithBasePath from "../../../../core/common/imageWithBasePath";
import CountUp from "react-countup";
import { motion, Variants } from "framer-motion";

interface DashboardData {
  sales: {
    total_sales: number;
    scts_sales: number;
    ets_sales: number;
  };
  revenue: {
    total_revenue: number;
    scts_revenue: number;
    ets_revenue: number;
  };
}

interface StudentsCardInteface {
  total_students: number;
  ETS_students: number;
  SCTS_students: number;
  total_teachers: number;
  SCTS_teachers: number;
  ETS_teachers: number;
}

interface callData {
  total_calls: number;
  answered_calls: number
  scts_calls: number
  scts_answered_calls: number
  ets_calls: number
  ets_answered_calls: number
}

const Cards = () => {
  const { userPermissions, webApi } = useUserPermissions();
  const jwtToken = Cookies.get("authToken");
  const routes = all_routes;
  const navigate = useNavigate();
  const [data, setData] = useState<DashboardData | null>(null);
  const [callCard, setCallCard] = useState<callData | null>(null);
  const [studentsData, setStusentsData] = useState<StudentsCardInteface>();
  const [loading, setLoading] = useState(true);
  const [selectedfilter, setSelectedFilter] = useState("");
  const [showTooltip, setShowTooltip] = useState(false);

  const FILTERS = [
    { label: "Today", value: "today" },
    { label: "Week", value: "week" },
    { label: "Month", value: "month" },
    { label: "Overall", value: "" },
  ];

  const cardVariants: Variants = {
    hidden: {
      opacity: 0,
      y: 30,
    },
    visible: (index: number) => ({
      opacity: 1,
      y: 0,
      transition: {
        delay: index * 0.1,
        duration: 0.5,
        ease: [0.25, 0.1, 0.25, 1], // ← cubic-bezier (easeOut)
      },
    }),
  };

  const options = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${jwtToken}`,
    },
  };

  //  Cards Data
  const fetchCardsData = async () => {
    try {
      setLoading(true);
      const response = await fetch(
        `${webApi}/sed/get_sale_revenue_cards/?filter=${selectedfilter}`,
        options,
      );
      const data = await response.json();
      if (!response.ok) {
        const errorData = await response.json();
        if (errorData.code === "token_not_valid") {
          navigate("/academic/sri-chaitanya/crm/landing-page");
        }
        throw new Error(errorData.detail || "Failed to fetch SED cards data");
      }
      setData(data.results);
    } catch (error: any) {
    } finally {
      setLoading(false);
    }
  };

  //  Calls  Data
  const fetchCallCardsData = async () => {
    try {
      setLoading(true);
      const response = await fetch(
        `${webApi}/sed/get_call_details_card/?filter=${selectedfilter}`,
        options,
      );
      const data = await response.json();
      if (!response.ok) {
        const errorData = await response.json();
        if (errorData.code === "token_not_valid") {
          navigate("/academic/sri-chaitanya/crm/landing-page");
        }
        throw new Error(errorData.detail || "Failed to fetch SED cards data");
      }
      setCallCard(data.results);
    } catch (error: any) {
    } finally {
      setLoading(false);
    }
  };

  //  Students Data
  const fetchStudentsData = async () => {
    try {
      setLoading(true);
      const response = await fetch(
        `${webApi}/sed/get_students_and_teacher_cards_data/`,
        options,
      );
      const data = await response.json();
      if (!response.ok) {
        const errorData = await response.json();
        if (errorData.code === "token_not_valid") {
          navigate("/academic/sri-chaitanya/crm/landing-page");
        }
        throw new Error(errorData.detail || "Failed to fetch SED cards data");
      }
      setStusentsData(data.results);
    } catch (error: any) {
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchStudentsData();
  }, []);

  useEffect(() => {
    fetchCardsData();
    fetchCallCardsData();
  }, [selectedfilter]);

  const formatCurrency = (value: number | undefined) => {
    if (!value) return "₹0";

    if (value >= 10000000) return `₹${(value / 10000000).toFixed(2)} Cr`;
    if (value >= 100000) return `₹${(value / 100000).toFixed(2)} L`;
    if (value >= 1000) return `₹${(value / 1000).toFixed(1)} K`;

    return `₹${value.toFixed(0)}`;
  };

  if (loading) return <Spin />;

  return (
    <div className="container ">
      {/* Filter Top Right */}

      {/* Cards Row */}
      <div className="row ">
        <div className="col-xxl-3 col-sm-6 d-flex">
          <div className="card flex-fill animate-card border-0">
            <div className="card-body">
              <div className="d-flex align-items-center">
                <div className="avatar avatar-xl me-2 p-1">
                  <ImageWithBasePath src="/assets/img/students_2995620.png" />
                </div>

                <div className="overflow-hidden flex-fill">
                  <div className="d-flex align-items-center justify-content-between">
                    <h2 className="counter">{studentsData?.total_students}</h2>
                  </div>

                  <p>{"Students"}</p>
                </div>
              </div>

              {/* Bottom section */}
              <div className="d-flex align-items-center justify-content-between border-top mt-3 pt-3">
                <p className="mb-0">
                  {"SCTS Students"} :{" "}
                  <span className="text-dark fw-semibold">
                    {studentsData?.SCTS_students}
                  </span>
                </p>

                <span className="text-light">|</span>

                <p className="mb-0">
                  {"ETS Students"} :{" "}
                  <span className="text-dark fw-semibold">
                    {/* {todayLeads?.total_calls - todayLeads?.connected_calls} */}
                    {studentsData?.ETS_students}
                  </span>
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="col-xxl-3 col-sm-6 d-flex">
          <div className="card flex-fill animate-card border-0">
            <div className="card-body">
              <div className="d-flex align-items-center">
                <div className="avatar avatar-xl me-2 p-1">
                  <ImageWithBasePath src="/assets/img/Teachers.png" />
                </div>

                <div className="overflow-hidden flex-fill">
                  <div className="d-flex align-items-center justify-content-between">
                    <h2 className="counter">{studentsData?.total_teachers}</h2>
                  </div>

                  <p>{"Teachers"}</p>
                </div>
              </div>

              {/* Bottom section */}
              <div className="d-flex align-items-center justify-content-between border-top mt-3 pt-3">
                <p className="mb-0">
                  {"SCTS Teachers"} :{" "}
                  <span className="text-dark fw-semibold">
                    {studentsData?.SCTS_teachers}
                  </span>
                </p>

                <span className="text-light">|</span>

                <p className="mb-0">
                  {"ETS Teachers"} :{" "}
                  <span className="text-dark fw-semibold">
                    {/* {todayLeads?.total_calls - todayLeads?.connected_calls} */}
                    {studentsData?.ETS_teachers}
                  </span>
                </p>
              </div>
            </div>
          </div>
        </div>
        {/* Empty container for cards  */}
        <div></div>
        <div></div>
      </div>

      <div className="row ">
        <div className="col-12 d-flex justify-content-between">
          <div>
            <h3>Overall Matrix</h3>
          </div>
          <select
            className="form-select w-auto"
            value={selectedfilter}
            onChange={(e) => setSelectedFilter(e.target.value)}
          >
            {FILTERS.map((filter) => (
              <option key={filter.value || "overall"} value={filter.value}>
                {filter.label}
              </option>
            ))}
          </select>
        </div>
      </div>

      <div className="row">
        <div className="col-xxl-3 col-sm-6 d-flex">
          <motion.div
            className="card flex-fill animate-card border-0"
            variants={cardVariants}
            initial="hidden"
            animate="visible"
            whileHover={{
              y: -6,
              scale: 1.02,
              boxShadow: "0px 10px 25px rgba(0,0,0,0.12)",
            }}
          >
            <div className="card-body">
              <div className="d-flex align-items-center">
                <div className="avatar avatar-xl me-2 p-1">
                  <ImageWithBasePath src="/assets/img/sales.avif" />
                </div>

                <div className="overflow-hidden flex-fill">
                  <div className="d-flex align-items-center justify-content-between">
                    <h2 className="counter">
                      <CountUp end={Number(data?.sales.total_sales)} />
                    </h2>
                  </div>

                  <p>{"Sales"}</p>
                </div>
              </div>

              {/* Bottom section */}
              <div className="d-flex align-items-center justify-content-between border-top mt-3 pt-3">
                <p className="mb-0">
                  {"SCTS Sales"} :{" "}
                  <span className="text-dark fw-semibold">
                    {data?.sales.scts_sales}
                  </span>
                </p>

                <span className="text-light">|</span>

                <p className="mb-0">
                  {"ETS Sales"} :{" "}
                  <span className="text-dark fw-semibold">
                    {/* {todayLeads?.total_calls - todayLeads?.connected_calls} */}
                    {data?.sales.ets_sales}
                  </span>
                </p>
              </div>
            </div>
          </motion.div>
        </div>

        <div className="col-xxl-3 col-sm-6 d-flex">
          <motion.div
            className="card flex-fill animate-card border-0"
            variants={cardVariants}
            initial="hidden"
            animate="visible"
            whileHover={{
              y: -6,
              scale: 1.02,
              boxShadow: "0px 10px 25px rgba(0,0,0,0.12)",
            }}
          >
            <div className="card-body">
              <div className="d-flex align-items-center">
                <div className="avatar avatar-xl me-2 p-1">
                  <ImageWithBasePath src="/assets/img/rupee.jpg" />
                </div>

                <div className="overflow-hidden flex-fill">
                  <div className="d-flex align-items-center justify-content-between">
                    <h2 className="counter">
                      {formatCurrency(data?.revenue?.total_revenue)}
                    </h2>
                  </div>

                  <p>{"Revenue"}</p>
                </div>
              </div>

              {/* Bottom section */}
              <div className="d-flex align-items-center justify-content-between border-top mt-3 pt-3">
                <p className="mb-0">
                  {"SCTS"} :{" "}
                  <span className="text-dark fw-semibold">
                    {data?.revenue.scts_revenue}
                  </span>
                </p>

                <span className="text-light">|</span>

                <p className="mb-0">
                  {"ETS"} :{" "}
                  <span className="text-dark fw-semibold">
                    {/* {todayLeads?.total_calls - todayLeads?.connected_calls} */}
                    {data?.revenue.ets_revenue}
                  </span>
                </p>
              </div>
            </div>
          </motion.div>
        </div>

        <div className="col-xxl-3 col-sm-6 d-flex">
          <motion.div
            className="card flex-fill animate-card border-0"
            variants={cardVariants}
            initial="hidden"
            animate="visible"
            whileHover={{
              y: -6,
              scale: 1.02,
              boxShadow: "0px 10px 25px rgba(0,0,0,0.12)",
            }}
          >
            <div className="card-body">
              <div className="d-flex align-items-center">
                <div className="avatar avatar-xl me-2 p-1">
                  <ImageWithBasePath src="assets/img/phone-call_1759915.png" />
                </div>

                <div className="overflow-hidden flex-fill">
                  <div className="d-flex align-items-center justify-content-between">
                    <h2 className="counter">
                      {callCard?.answered_calls} / {callCard?.total_calls}
                    </h2>
                  </div>

                  <p>{"Answered Calls "}</p>
                </div>
              </div>

              {/* Bottom section */}
              <div className="d-flex align-items-center justify-content-between border-top mt-3 pt-3">
                <p className="mb-0">
                  {"SCTS"} :{" "}
                  <span className="text-dark fw-semibold">
                    {callCard?.scts_answered_calls} / {callCard?.scts_calls}
                  </span>
                </p>

                <span className="text-light">|</span>

                <p className="mb-0">
                  {"ETS"} :{" "}
                  <span className="text-dark fw-semibold">
                    {/* {todayLeads?.total_calls - todayLeads?.connected_calls} */}
                    {callCard?.ets_answered_calls} / {callCard?.ets_calls}
                  </span>
                </p>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </div>
  );
};

export default Cards;
